import { useIntl } from 'react-intl';
import { ReactNode } from 'react';
import { messages } from './messages';

export type Messages = keyof typeof messages;
type PrimitiveType = string | number | boolean | null | undefined | Date;
type Values = Record<string, PrimitiveType | ReactNode | (<T>(chunks: T[]) => ReactNode)>;

export const useMessage = () => {
  const { formatMessage } = useIntl();

  // @ts-expect-error Fix types
  function format(msgId: Messages, values?: Record<string, string>): string;
  function format(msgId: Messages, values?: Record<string, ReactNode | (<T>(chunks: T[]) => ReactNode)>): ReactNode;
  function format(msgId: Messages, values?: Values) {
    if (!messages[msgId]) {
      throw new Error(`Message with id "${msgId}" is not found in messages`);
    }
    return formatMessage(messages[msgId], values);
  }

  return format;
};
